import { persistor, store } from "./store/store";

import { App } from "./components";
import CssBaseline from "@mui/material/CssBaseline";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import reportWebVitals from "./reportWebVitals";
import { FeatureFlagsProvider } from "./contexts";
import { useEffect, useState } from "react";
import { fetchFeatureFlags } from "./services/featureFlags";

import theme from "./theme/theme";

const AppWithFeatureFlags = () => {
  const [flags, setFlags] = useState<Record<string, boolean>>({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadFeatureFlags = async () => {
      const featureFlags = await fetchFeatureFlags();
      setFlags(featureFlags);
      setIsLoading(false);
    };

    loadFeatureFlags();
  }, []);

  if (isLoading) {
    return null;
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <FeatureFlagsProvider value={flags}>
            <App />
          </FeatureFlagsProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<AppWithFeatureFlags />);

reportWebVitals();
